<div class="lista-cartoes">
    <mat-list>

        <mat-list-item *ngFor="let creditCard of creditCards">
            <div class="lista-cartao-ativar">
                <img class="cartao-bandeira" src="assets/images/{{creditCard.bandeira}}.png" height="25" style="padding-top: 8px" alt="cartao">
                
                <h2>**** **** **** {{ creditCard.finalNumero }}</h2>
                <div class="deleteDependente">
                    <button class="delete" (click)="delete(creditCard.id)">
                        <i class="material-icons">delete_forever</i>
                    </button>
                </div>
            </div>
        </mat-list-item>

        <mat-list-item *ngIf="creditCardAlreadySearched && creditCards.length == 0">
            <div class="lista-cartao-ativar">
                <h2>Ainda não há cartões cadastrados!</h2>
            </div>
        </mat-list-item>
        <mat-list-item *ngIf="creditCardAlreadySearched">
            <div class="lista-cartao-ativar">
                <p class="translation">* Para validação do seu cartão de crédito, a financeira fará uma transação no valor
                    de R$ 1,00 a R$5,00, apenas uma única vez. Mas não se preocupe, esta transação será estornada automaticamente.</p>
            </div>
        </mat-list-item>
    </mat-list>

    <button *ngIf="creditCardAlreadySearched" mat-raised-button class="confirma confirma-edit" (click)="goToRegisterCreditCard()">
        Cadastrar um novo cartão
    </button>
    
    <div class="backgroundTrasparente"></div>

</div>





// WEBPACK FOOTER //
// /usr/src/app/src/app/components/credit-card/credit-card.component.html